var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenAccessPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7857 0C16.4564 0 17 0.543662 17 1.21429V20.6429C17 21.3136 16.4564 21.8572 15.7857 21.8572H1.21429C0.54365 21.8572 0 21.3136 0 20.6429V1.21429C0 0.543662 0.54365 0 1.21429 0H15.7857ZM14.5714 2.42858H2.42858V19.4286H14.5714V2.42858ZM12.1428 9.71432V12.1429H9.71426V9.71432H12.1428Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenAccessPoint);
export default __webpack_public_path__ + "static/media/greenAccessPoint.523647a262fcb1bc7e1a87cccd2c5ce0.svg";
export { ForwardRef as ReactComponent };